import { render, staticRenderFns } from "./Ellipsis.vue?vue&type=template&id=359f20a9&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Ellipsis.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Ellipsis.vue
// module id = 2401
// module chunks = 1